import React from 'react';
import { SimpleTableMenuCellProps } from '../simple-table-row/simple-table-row.props';
import { MoreMenuItem } from 'components/more';
import { Flex } from 'common/common-components.styled';
import { StyledMore } from '../simple-table.styled';

const MenuCell = <TRow,>({ column, row }: SimpleTableMenuCellProps<TRow>) => {
  return (
    <Flex width={column.width || '100%'} align='center' justify='center'>
      <StyledMore>
        {column.menuItems.map(menuItem => (
          <MoreMenuItem
            key={menuItem.label}
            label={menuItem.label}
            img={menuItem.icon}
            onClick={() => menuItem.onClick(row)}
            isLeftPositionImg
          />
        ))}
      </StyledMore>
    </Flex>
  );
};

export default MenuCell;
